export default __webpack_public_path__ + "static/media/cert_others.48e35a66.svg";